module.exports = __webpack_public_path__ + "img/google-down.633f046d.png";